import React, { Component } from 'react';
import { size as _size, remove as _remove } from 'lodash';
import { injectIntl } from 'react-intl';
import { i18nIntl, isDesktop } from '../../lib/ep.js';
import { Stage, Layer, Rect, Text, Group, Path } from 'react-konva';

import ActionLink from '../builder/ActionLink';
import Spinner from '../builder/Spinner';

import DefaultMineIcon from '../svg/DefaultMineIcon';
import DefaultFlagIcon from '../svg/DefaultFlagIcon';
import MineSweeperControls from '../svg/MineSweeperControls';

const CrossSVG = (props) => {
	const size_portion = (props.size_portion != undefined) ? props.size_portion : 25;
	const path_scale = (props.path_scale != undefined) ? props.path_scale : 1;
	const x = (props.x != undefined) ? props.x : 0;
	const y = (props.y != undefined) ? props.y : 0;
	const init_x = (props.init_x != undefined) ? props.init_x : 0;
	const init_y = (props.init_y != undefined) ? props.init_y : 0;

	return (
		<Group>
			<Path
				fill="red"
				data="M 10,10 L 30,30 M 30,10 L 10,30"
				width={size_portion}
				height={size_portion}
				pos_x={x}
				pos_y={y}
				x={init_x}
				y={init_y}
				scaleX={path_scale}
				scaleY={path_scale}
				stroke="red"
				strokeWidth={5}
				lineCap="round"
				lineJoin="round"
			/>
		</Group>
	)
}

const FlaggingMobileFX = (props) => {
	const size_portion = (props.size_portion != undefined) ? props.size_portion : 25;
	const path_scale = (props.path_scale != undefined) ? props.path_scale : 1;
	const longitude_zone = (props.longitude_zone != undefined) ? props.longitude_zone : 3;

	const animation_size = size_portion * longitude_zone;

	const color = (props.color != undefined) ? props.color : 'rgba(0, 0, 0, 1)';

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={animation_size} height={animation_size} viewBox="0 0 100 100">
			<defs>
				<clipPath id="mask_1_original">
					<path d="M99.27,49.31c0,0-5.75-1.81-11.31-1.81c-10.43,0-26.74,1.71-26.74,1.71c-0.39,0.04-0.72,0.17-0.94,0.34c-4.09,0.11-7.7,0.13-7.96-0.51l-1.35-1.35c-0.64-0.27-0.63-3.87-0.51-7.96c0.17-0.22,0.3-0.54,0.34-0.94c0,0,1.71-16.32,1.71-26.74c0-5.56-1.81-11.31-1.81-11.31C50.55,0.3,50.29,0,50,0c-0.29,0-0.55,0.3-0.69,0.73c0,0-1.81,5.75-1.81,11.31c0,10.43,1.71,26.74,1.71,26.74c0.04,0.39,0.17,0.72,0.34,0.94c0.11,4.09,0.13,7.7-0.51,7.96l-1.35,1.35c-0.27,0.64-3.87,0.63-7.96,0.51c-0.22-0.17-0.54-0.3-0.94-0.34c0,0-16.32-1.71-26.74-1.71c-5.56,0-11.31,1.81-11.31,1.81C0.3,49.45,0,49.71,0,50c0,0.29,0.3,0.55,0.73,0.69c0,0,5.75,1.81,11.31,1.81c10.43,0,26.74-1.71,26.74-1.71c0.39-0.04,0.72-0.17,0.94-0.34c4.09-0.11,7.7-0.13,7.96,0.51l1.35,1.35c0.64,0.27,0.63,3.87,0.51,7.96c-0.17,0.22-0.3,0.54-0.34,0.94c0,0-1.71,16.32-1.71,26.74c0,5.56,1.81,11.31,1.81,11.31C49.45,99.7,49.71,100,50,100c0.29,0,0.55-0.3,0.69-0.73c0,0,1.81-5.75,1.81-11.31c0-10.43-1.71-26.74-1.71-26.74c-0.04-0.39-0.17-0.72-0.34-0.94c-0.11-4.09-0.13-7.7,0.51-7.96l1.35-1.35c0.27-0.64,3.87-0.63,7.96-0.51c0.22,0.17,0.54,0.3,0.94,0.34c0,0,16.32,1.71,26.74,1.71c5.56,0,11.31-1.81,11.31-1.81C99.7,50.55,100,50.29,100,50C100,49.71,99.7,49.45,99.27,49.31z" />
				</clipPath>

				<clipPath id="mask_2_original">
					<path d="M76.61,22.63c0,0-4.14,2.16-7.19,5.2c-5.71,5.71-13.71,15.59-13.71,15.59c-0.19,0.24-0.3,0.49-0.33,0.7c-2.18,2.3-4.15,4.29-4.64,4.08h-1.48c-0.5,0.21-2.46-1.78-4.64-4.08c-0.03-0.21-0.13-0.46-0.33-0.7c0,0-8-9.88-13.71-15.59c-3.05-3.05-7.19-5.2-7.19-5.2c-0.32-0.16-0.62-0.19-0.78-0.02c-0.16,0.16-0.14,0.46,0.02,0.78c0,0,2.16,4.14,5.2,7.19c5.71,5.71,15.59,13.71,15.59,13.71c0.24,0.19,0.49,0.3,0.7,0.33c2.3,2.18,4.29,4.15,4.08,4.64v1.48c0.21,0.5-1.78,2.46-4.08,4.64c-0.21,0.03-0.46,0.13-0.7,0.33c0,0-9.88,8-15.59,13.71c-3.05,3.05-5.2,7.19-5.2,7.19c-0.16,0.32-0.19,0.62-0.02,0.78c0.16,0.16,0.46,0.14,0.78-0.02c0,0,4.14-2.16,7.19-5.2c5.71-5.71,13.71-15.59,13.71-15.59c0.19-0.24,0.3-0.49,0.33-0.7c2.18-2.3,4.15-4.29,4.64-4.08h1.48c0.5-0.21,2.46,1.78,4.64,4.08c0.03,0.21,0.13,0.46,0.33,0.7c0,0,8,9.88,13.71,15.59c3.05,3.05,7.19,5.2,7.19,5.2c0.32,0.16,0.62,0.19,0.78,0.02c0.16-0.16,0.14-0.46-0.02-0.78c0,0-2.16-4.14-5.2-7.19c-5.71-5.71-15.59-13.71-15.59-13.71c-0.24-0.19-0.49-0.3-0.7-0.33c-2.3-2.18-4.29-4.15-4.08-4.64v-1.48c-0.21-0.5,1.78-2.46,4.08-4.64c0.21-0.03,0.46-0.13,0.7-0.33c0,0,9.88-8,15.59-13.71c3.05-3.05,5.2-7.19,5.2-7.19c0.16-0.32,0.19-0.62,0.02-0.78C77.23,22.45,76.93,22.47,76.61,22.63z"/>
				</clipPath>

				<clipPath id="mask_1">
					<path d="M99.82,49.85c-1.66-0.29-3.33-0.44-4.96-0.59c-0.43-0.04-0.86-0.08-1.3-0.12c-0.37-0.03-0.75-0.07-1.12-0.11c-0.65-0.06-1.33-0.13-2-0.18c-1.13-0.08-2.16-0.12-3.14-0.11c-1.94,0-3.99,0.06-6.24,0.18c-0.86,0.05-1.73,0.1-2.59,0.16c-1.19,0.08-2.42,0.15-3.62,0.21c-1.69,0.08-3.41,0.13-5.07,0.17l-1.14,0.03c-1.49,0.04-2.97,0.08-4.46,0.11l-7.97,0.16l-0.95,0.01c-0.92,0.01-1.85,0.03-2.79,0.04c-0.08-1.24-1.07-2.22-2.31-2.31c0.01-0.94,0.02-1.87,0.04-2.79l0.13-7.17l0.04-1.72c0.04-1.5,0.07-3,0.11-4.5l0.03-1.12c0.05-1.67,0.09-3.4,0.17-5.09c0.06-1.21,0.14-2.44,0.21-3.63c0.05-0.86,0.11-1.72,0.16-2.59c0.13-2.26,0.19-4.3,0.18-6.24c0-0.98-0.03-2.01-0.11-3.14c-0.05-0.67-0.11-1.35-0.18-2c-0.04-0.37-0.07-0.74-0.11-1.12c-0.04-0.43-0.08-0.86-0.12-1.3c-0.15-1.62-0.3-3.3-0.59-4.95c-0.04-0.21-0.24-0.21-0.28,0c-0.29,1.66-0.44,3.33-0.59,4.95c-0.04,0.43-0.08,0.86-0.12,1.3c-0.03,0.37-0.07,0.74-0.11,1.12c-0.06,0.66-0.13,1.33-0.18,2c-0.08,1.13-0.11,2.16-0.11,3.14c0,1.94,0.06,3.99,0.18,6.24c0.05,0.86,0.1,1.72,0.16,2.58c0.08,1.19,0.15,2.43,0.21,3.64c0.08,1.7,0.13,3.43,0.17,5.1l0.03,1.12c0.04,1.49,0.08,2.97,0.11,4.46l0.16,7.97l0.01,0.96c0.01,0.92,0.03,1.85,0.04,2.79c-1.24,0.08-2.22,1.07-2.31,2.31c-0.94-0.01-1.87-0.02-2.79-0.04l-7.17-0.13l-1.76-0.04c-1.49-0.03-2.97-0.07-4.46-0.11l-1.14-0.03c-1.66-0.05-3.38-0.09-5.07-0.17c-1.21-0.06-2.44-0.13-3.62-0.21c-0.86-0.05-1.73-0.11-2.59-0.16c-2.25-0.13-4.3-0.18-6.24-0.18c-0.99,0-2.01,0.03-3.14,0.11c-0.67,0.05-1.35,0.11-2,0.18c-0.37,0.04-0.75,0.07-1.12,0.11C6,49.18,5.56,49.22,5.13,49.26c-1.62,0.15-3.3,0.3-4.96,0.59C0.07,49.87,0,49.93,0,49.99c0,0.06,0.07,0.12,0.18,0.14c1.65,0.29,3.33,0.44,4.95,0.59c0.43,0.04,0.87,0.08,1.3,0.12c0.37,0.03,0.74,0.07,1.11,0.11c0.66,0.06,1.33,0.13,2,0.18c1.1,0.08,2.11,0.11,3.07,0.11c0.06,0,0.13,0,0.19,0c1.91,0,3.91-0.06,6.12-0.18c0.86-0.05,1.72-0.1,2.58-0.16c1.19-0.08,2.43-0.15,3.64-0.21c1.7-0.08,3.44-0.13,5.11-0.18l1.1-0.03c1.49-0.04,2.97-0.08,4.46-0.11l7.97-0.16l0.96-0.01c0.91-0.01,1.85-0.03,2.78-0.04c0.08,1.24,1.07,2.22,2.31,2.31c-0.01,0.94-0.02,1.87-0.04,2.79l-0.13,7.17l-0.04,1.76c-0.03,1.49-0.07,2.97-0.11,4.46l-0.03,1.11c-0.05,1.67-0.09,3.4-0.17,5.1c-0.06,1.21-0.14,2.45-0.21,3.64c-0.05,0.86-0.11,1.72-0.16,2.58c-0.13,2.26-0.19,4.3-0.18,6.24c0,0.98,0.03,2.01,0.11,3.14c0.05,0.67,0.11,1.35,0.18,2c0.04,0.37,0.07,0.74,0.11,1.12c0.04,0.43,0.08,0.86,0.12,1.3c0.15,1.62,0.3,3.3,0.59,4.95C49.88,99.93,49.94,100,50,100c0.06,0,0.12-0.07,0.14-0.18c0.29-1.66,0.44-3.33,0.59-4.95c0.04-0.43,0.08-0.86,0.12-1.3c0.03-0.37,0.07-0.74,0.11-1.11c0.06-0.66,0.13-1.33,0.18-2c0.08-1.13,0.11-2.16,0.11-3.14c0-1.95-0.06-3.99-0.18-6.24c-0.05-0.86-0.1-1.72-0.16-2.58c-0.08-1.19-0.15-2.42-0.21-3.63c-0.08-1.7-0.13-3.42-0.17-5.1l-0.03-1.12c-0.04-1.5-0.08-3-0.11-4.5l-0.16-7.93l-0.01-0.96c-0.01-0.92-0.03-1.85-0.04-2.79c1.24-0.08,2.22-1.07,2.31-2.31c0.93,0.01,1.87,0.02,2.78,0.04l7.18,0.13l1.76,0.04c1.49,0.03,2.97,0.07,4.46,0.11l1.1,0.03c1.68,0.05,3.41,0.09,5.11,0.18c1.21,0.06,2.44,0.14,3.64,0.21c0.86,0.05,1.72,0.11,2.58,0.16c2.21,0.12,4.21,0.18,6.12,0.18c0.04,0,0.08,0,0.12,0c0.98,0,2.01-0.04,3.14-0.11c0.67-0.05,1.35-0.11,2-0.18c0.37-0.04,0.74-0.07,1.12-0.11c0.43-0.04,0.87-0.08,1.3-0.12c1.62-0.15,3.29-0.3,4.95-0.59c0.11-0.02,0.18-0.07,0.18-0.14C100,49.93,99.93,49.87,99.82,49.85z" />
				</clipPath>

				<clipPath id="mask_2">
					<path d="M87.53,28.32c-0.03-0.05-0.12-0.07-0.21-0.03c-1.39,0.47-2.73,1.06-4.02,1.64c-0.34,0.15-0.69,0.3-1.03,0.46c-0.24,0.11-0.48,0.21-0.72,0.32c-0.58,0.25-1.18,0.51-1.76,0.79c-0.79,0.37-1.6,0.8-2.42,1.27c-1.46,0.84-2.96,1.78-4.6,2.87c-0.62,0.41-1.24,0.83-1.86,1.25c-0.86,0.58-1.74,1.18-2.62,1.76c-1.06,0.7-2.16,1.38-3.23,2.04c-0.44,0.27-0.88,0.55-1.32,0.82c-1.12,0.7-2.24,1.39-3.36,2.08l-5.82,3.54l-0.69,0.41c-0.59,0.35-1.19,0.71-1.8,1.07c-0.45-0.66-1.2-1.1-2.06-1.1c-0.39,0-0.76,0.1-1.09,0.26c-0.34-0.61-0.68-1.23-1.02-1.83l-2.98-5.43l-0.71-1.32c-0.62-1.14-1.24-2.28-1.84-3.42c-0.24-0.46-0.49-0.91-0.73-1.37c-0.59-1.11-1.21-2.25-1.78-3.39c-0.47-0.94-0.94-1.9-1.39-2.83c-0.32-0.67-0.65-1.34-0.98-2.01c-0.87-1.76-1.7-3.32-2.55-4.78c-0.47-0.82-0.96-1.59-1.46-2.3c-0.37-0.53-0.76-1.06-1.13-1.57c-0.16-0.21-0.31-0.42-0.46-0.63c-0.22-0.3-0.44-0.61-0.67-0.91c-0.83-1.14-1.69-2.33-2.66-3.43c-0.07-0.08-0.15-0.11-0.2-0.08c-0.05,0.03-0.07,0.12-0.03,0.21c0.47,1.39,1.06,2.73,1.64,4.02c0.15,0.34,0.3,0.69,0.46,1.03c0.11,0.24,0.21,0.48,0.32,0.72c0.25,0.58,0.51,1.18,0.79,1.76c0.37,0.8,0.79,1.59,1.27,2.42c0.84,1.46,1.78,2.97,2.87,4.6c0.41,0.62,0.84,1.24,1.26,1.86c0.58,0.85,1.18,1.74,1.75,2.62c0.7,1.06,1.38,2.17,2.04,3.23c0.27,0.44,0.55,0.88,0.82,1.32c0.69,1.1,1.36,2.21,2.04,3.31l3.58,5.88l0.42,0.7c0.35,0.59,0.71,1.19,1.07,1.79c-0.66,0.45-1.1,1.2-1.1,2.07c0,0.39,0.1,0.76,0.26,1.09c-0.62,0.34-1.23,0.69-1.84,1.02l-5.42,2.98l-1.29,0.7c-1.15,0.62-2.29,1.24-3.44,1.86c-0.46,0.24-0.91,0.49-1.36,0.73c-1.11,0.59-2.25,1.21-3.4,1.78c-0.93,0.47-1.9,0.94-2.83,1.39c-0.67,0.33-1.35,0.65-2.02,0.98c-1.76,0.87-3.32,1.7-4.78,2.55c-0.83,0.48-1.58,0.96-2.3,1.46c-0.53,0.36-1.05,0.75-1.56,1.13c-0.21,0.16-0.43,0.32-0.64,0.47c-0.3,0.22-0.61,0.44-0.91,0.67c-1.14,0.83-2.33,1.69-3.43,2.66c-0.08,0.07-0.11,0.15-0.08,0.2c0.03,0.04,0.09,0.06,0.17,0.05c0.01,0,0.03-0.01,0.04-0.01c1.39-0.47,2.73-1.06,4.02-1.64c0.34-0.15,0.69-0.3,1.03-0.46c0.24-0.11,0.48-0.21,0.72-0.32c0.58-0.25,1.18-0.51,1.76-0.79c0.79-0.37,1.6-0.8,2.42-1.27c1.46-0.84,2.96-1.78,4.6-2.87c0.62-0.41,1.24-0.83,1.86-1.25c0.86-0.58,1.74-1.18,2.62-1.76c1.07-0.7,2.17-1.39,3.24-2.05c0.44-0.27,0.88-0.54,1.31-0.81c1.1-0.69,2.21-1.37,3.32-2.05l5.87-3.57l0.7-0.42c0.59-0.35,1.18-0.71,1.78-1.07c0.45,0.66,1.2,1.1,2.06,1.1c0.39,0,0.76-0.1,1.09-0.26c0.34,0.61,0.68,1.22,1.02,1.82l2.99,5.43l0.71,1.31c0.62,1.14,1.24,2.28,1.85,3.43c0.24,0.46,0.49,0.92,0.74,1.38c0.59,1.1,1.2,2.24,1.77,3.38c0.47,0.93,0.94,1.9,1.39,2.83c0.33,0.67,0.65,1.35,0.98,2.02c0.87,1.76,1.7,3.32,2.55,4.78c0.47,0.82,0.96,1.59,1.46,2.3c0.36,0.53,0.75,1.05,1.12,1.56c0.16,0.21,0.32,0.43,0.47,0.64c0.22,0.3,0.45,0.61,0.67,0.91c0.83,1.14,1.69,2.32,2.66,3.43c0.04,0.04,0.08,0.07,0.12,0.08c0.03,0.01,0.06,0.01,0.08-0.01c0.05-0.03,0.07-0.12,0.03-0.21c-0.47-1.39-1.06-2.72-1.64-4.02c-0.15-0.34-0.31-0.69-0.46-1.04c-0.11-0.24-0.21-0.48-0.31-0.72c-0.25-0.58-0.51-1.18-0.79-1.76c-0.37-0.79-0.8-1.6-1.27-2.42c-0.84-1.46-1.78-2.96-2.87-4.6c-0.41-0.62-0.83-1.24-1.25-1.86c-0.58-0.86-1.18-1.74-1.76-2.62c-0.7-1.06-1.38-2.16-2.04-3.23c-0.27-0.44-0.55-0.88-0.82-1.32c-0.69-1.1-1.37-2.21-2.04-3.31l-3.57-5.87l-0.42-0.7c-0.35-0.59-0.71-1.19-1.07-1.79c0.66-0.45,1.1-1.2,1.1-2.07c0-0.39-0.1-0.76-0.26-1.09c0.61-0.34,1.22-0.68,1.82-1.02l5.44-2.99l1.32-0.71c1.14-0.62,2.28-1.23,3.42-1.84c0.46-0.24,0.92-0.49,1.37-0.73c1.1-0.59,2.25-1.21,3.39-1.78c0.94-0.47,1.9-0.94,2.83-1.39c0.67-0.32,1.34-0.65,2.01-0.98c1.76-0.87,3.32-1.7,4.78-2.55c0.81-0.47,1.59-0.96,2.3-1.46c0.53-0.37,1.06-0.76,1.57-1.13c0.21-0.16,0.42-0.31,0.63-0.47c0.3-0.22,0.61-0.44,0.91-0.67c1.14-0.83,2.33-1.69,3.43-2.66C87.53,28.45,87.56,28.37,87.53,28.32z" />
				</clipPath>

				<clipPath id="mask_3">
					<path d="M82.49,68.6c-0.94-0.88-1.96-1.64-2.94-2.38c-0.26-0.2-0.52-0.39-0.77-0.59c-1.27-0.98-2.52-1.92-3.89-2.71c-1.27-0.73-2.63-1.45-4.16-2.19c-0.59-0.28-1.17-0.56-1.76-0.84c-0.81-0.38-1.65-0.77-2.46-1.18c-0.99-0.48-1.98-1.01-2.94-1.52c-0.4-0.21-0.79-0.42-1.19-0.63c-0.99-0.52-1.97-1.05-2.95-1.57l-5.26-2.85l-0.65-0.36c-0.42-0.23-0.84-0.47-1.26-0.7c0.16-0.33,0.26-0.69,0.26-1.09c0-0.86-0.43-1.61-1.1-2.06c0.26-0.43,0.52-0.87,0.78-1.29l2.78-4.56l0.7-1.13c0.59-0.95,1.17-1.89,1.77-2.84c0.24-0.38,0.48-0.76,0.72-1.14c0.58-0.92,1.17-1.88,1.79-2.79c0.5-0.76,1.03-1.52,1.54-2.25c0.37-0.53,0.74-1.07,1.11-1.6c0.96-1.41,1.78-2.71,2.51-3.98c0.8-1.37,1.41-2.81,2.02-4.29c0.12-0.3,0.25-0.6,0.38-0.9c0.48-1.13,0.98-2.31,1.36-3.54c0.03-0.09,0.01-0.17-0.04-0.2c-0.05-0.03-0.13,0-0.19,0.07c-0.88,0.94-1.64,1.96-2.38,2.94c-0.19,0.26-0.39,0.52-0.58,0.77c-0.98,1.27-1.92,2.52-2.71,3.89c-0.74,1.27-1.45,2.63-2.19,4.16c-0.28,0.59-0.56,1.17-0.84,1.76c-0.38,0.81-0.77,1.65-1.18,2.46c-0.48,0.99-1.01,1.98-1.52,2.94c-0.21,0.4-0.42,0.79-0.63,1.19c-0.52,0.99-1.05,1.97-1.57,2.95l-2.85,5.26l-0.34,0.61c-0.24,0.43-0.48,0.87-0.72,1.31C50.76,47.6,50.39,47.5,50,47.5c-0.86,0-1.61,0.43-2.06,1.09c-0.43-0.26-0.87-0.52-1.29-0.77l-4.56-2.78l-1.11-0.69c-0.95-0.59-1.91-1.18-2.86-1.78c-0.38-0.24-0.76-0.48-1.14-0.72c-0.92-0.58-1.88-1.17-2.79-1.79c-0.76-0.5-1.52-1.03-2.25-1.54c-0.53-0.37-1.07-0.74-1.6-1.11c-1.41-0.96-2.71-1.78-3.98-2.51c-1.37-0.8-2.81-1.41-4.29-2.02c-0.3-0.12-0.6-0.25-0.89-0.38c-1.13-0.48-2.31-0.98-3.54-1.36c-0.09-0.03-0.17-0.01-0.2,0.04c-0.03,0.05,0,0.13,0.07,0.19c0.94,0.88,1.96,1.64,2.94,2.38c0.26,0.19,0.52,0.39,0.77,0.59c1.27,0.98,2.52,1.93,3.89,2.71c1.27,0.73,2.63,1.45,4.16,2.19c0.58,0.28,1.17,0.56,1.76,0.84c0.81,0.38,1.65,0.77,2.46,1.18c0.99,0.48,1.98,1.01,2.94,1.52c0.4,0.21,0.79,0.42,1.19,0.63c1,0.53,1.99,1.06,2.99,1.59l5.22,2.83l0.6,0.33c0.43,0.24,0.87,0.48,1.31,0.73c-0.16,0.33-0.26,0.69-0.26,1.09c0,0.86,0.43,1.61,1.09,2.06c-0.25,0.41-0.49,0.83-0.74,1.24l-2.81,4.61L44.37,59c-0.59,0.96-1.18,1.91-1.78,2.86c-0.24,0.38-0.48,0.76-0.72,1.15c-0.58,0.92-1.17,1.87-1.79,2.79c-0.5,0.76-1.03,1.52-1.54,2.25c-0.37,0.53-0.74,1.07-1.11,1.6c-0.96,1.41-1.78,2.71-2.51,3.98c-0.8,1.37-1.41,2.81-2.02,4.29c-0.12,0.3-0.25,0.6-0.38,0.9c-0.48,1.13-0.98,2.31-1.36,3.54c-0.03,0.09-0.01,0.17,0.04,0.2c0.02,0.01,0.05,0.02,0.08,0.01c0.04-0.01,0.08-0.04,0.11-0.08c0.88-0.94,1.64-1.96,2.38-2.94c0.2-0.26,0.39-0.52,0.59-0.77c0.98-1.27,1.92-2.52,2.71-3.89c0.73-1.27,1.45-2.63,2.19-4.16c0.28-0.58,0.56-1.17,0.83-1.76c0.38-0.81,0.78-1.65,1.18-2.47c0.48-0.99,1.01-1.98,1.52-2.94c0.21-0.4,0.42-0.79,0.63-1.19c0.52-1,1.06-1.99,1.59-2.98l2.84-5.24l0.35-0.63c0.23-0.42,0.47-0.85,0.71-1.28c0.33,0.16,0.69,0.26,1.09,0.26c0.86,0,1.61-0.43,2.06-1.09c0.42,0.25,0.85,0.51,1.27,0.76l4.58,2.8l1.11,0.69c0.95,0.59,1.9,1.18,2.85,1.78c0.38,0.24,0.76,0.48,1.14,0.72c0.92,0.58,1.88,1.17,2.79,1.79c0.76,0.5,1.52,1.03,2.26,1.55c0.53,0.37,1.06,0.74,1.6,1.1c1.41,0.96,2.71,1.78,3.98,2.51c1.37,0.8,2.81,1.41,4.29,2.02c0.3,0.13,0.6,0.25,0.9,0.38c1.13,0.48,2.3,0.98,3.53,1.36c0.01,0,0.02,0.01,0.03,0.01c0.08,0.02,0.14,0,0.17-0.05C82.58,68.74,82.56,68.66,82.49,68.6z" />
				</clipPath>
			</defs>

			<g clipPath="url(#mask_1)">
				<circle id="flagging_circle_1" cx="50" cy="50" r="50" style={{stroke:color}} />
			</g>

			<g clipPath="url(#mask_2)">
				<circle id="flagging_circle_2" cx="50" cy="50" r="50" style={{stroke:color}} />
			</g>

			<g clipPath="url(#mask_3)">
				<circle id="flagging_circle_3" cx="50" cy="50" r="50" style={{stroke:color}} />
			</g>
		</svg>
	)
}

class MineSweeperCanvas extends Component {
	constructor(props,context) {
		super(props, context);

		this.state = {
			bomb_image:false,
			bomb_image_obj:{},
			bombs:[],
			clicks:[],
			columns:this.setGrid(props),
			display_controls:false,
			display_instructions:false,
			ended:false,
			flag_image:false,
			flag_image_obj:{},
			flags:[],
			full_loaded:false,
			map:[],
			solved:false,
			grid:(props.grid != undefined) ? props.grid : 'small',
			total_bombs:(props.mines != undefined) ? props.mines : 10,
			areas: [],
			show_result: props.show_result != undefined ? props.show_result : false,
			zone_press: false,
			exploded_bomb: '',
			//flagger:(props.flagger != undefined) ? props.flagger : false,
		}

		this.size = 600;

		this.bomb_image;
		this.flag_image;

		this.device = (isDesktop()) ? 'desktop' : 'mobile';

		this.bomb_char_id = "X";
		this.clear_char_id = "";
		this.flag_event = false;
		this.flagged_bombs = [];
		this.longitude_zone = 5;

		this.success_sound = props.sound_fx.success;
		this.click_cell_sound = props.sound_fx.flip;
		this.flag_cell_sound = props.sound_fx.flag;
		this.unflag_cell_sound = props.sound_fx.unplug;
		this.bomb_explode_sound = props.sound_fx.error;

		this.flag_bg_color = 'rgba(' + props.color_ok + ', 1)';
		this.exploded_bomb_bg_color = 'rgba(' + props.color_ko + ', 1)';
		this.cell_bg_color = 'rgba(' + props.cell_color + ', 1)';

		this.loadImages(props.mine_img,props.flag_img);

		if(props.stageInstance != undefined) props.stageInstance(this);

		this.handleButtonPress = this.handleButtonPress.bind(this);
		this.handleButtonRelease = this.handleButtonRelease.bind(this);

		//this.default_cache_props = { pixelRatio:2, imageSmoothingEnabled:true, offset:5, drawBorder:false };
	}

	/*START SOUNDS*/
	flagCellPlay() {
		this.flag_cell_sound.play();
	}

	unflagCellPlay() {
		this.unflag_cell_sound.play();
	}

	bombExplodePlay() {
		this.bomb_explode_sound.play();
	}

	successPlay() {
		this.success_sound.play();
	}

	clickCellPlay() {
		this.click_cell_sound.play();
	}

	clickAndExplodeBombPlay() {
		this.click_cell_sound.once('end', () => {
			this.bombExplodePlay();
		});
		this.click_cell_sound.play();
	}

	flagCellAndSuccessPlay() {
		this.flag_cell_sound.once('end', () => {
			this.successPlay();
		});
		this.flag_cell_sound.play();
	}
	/*END SOUNDS*/

	componentDidMount() {
		const t = setTimeout(() => {
		this.gameInit();
		}, 500);

		window.onresize = () => {
			this.gameInit(true);
		}
	}

	componentWillMount() {
		this.setGrid(this.props);
	}

	displayControls() {
		this.setState({ display_controls:!this.state.display_controls, display_instructions:false });
	}

	displayInstructions() {
		this.setState({ display_controls:false, display_instructions:!this.state.display_instructions });
	}

	closeAllLayer() {
		this.setState({ display_controls:false, display_instructions:false });
	}

	setGrid(props) {
		var columns;
		switch(props.grid) {
			case 'large':
				columns = 14;
				break;
			case 'medium':
				columns = 10;
				break;
			case 'small':
			default:
				columns = 6;
				break;
		}
		return columns;
	}

	componentWillReceiveProps(props) {
		//if(props.flagger != this.state.flagger) this.state.flagger = props.flagger;
		if(props.mine_img != this.props.mine_img || props.flag_img != this.props.flag_img) this.loadImages(props.mine_img,props.flag_img);
		if(props.grid != this.props.grid || props.color_ok != this.props.color_ok || props.color_ko != this.props.color_ko || props.mines != this.props.mines || props.cell_color != this.props.cell_color) {
			if(props.color_ok != this.props.color_ok) {
				this.flag_bg_color = 'rgba(' + props.color_ok + ', 1)';
			}
			if(props.color_ko != this.props.color_ko) {
				this.exploded_bomb_bg_color = 'rgba(' + props.color_ko + ', 1)';
			}
			if(props.grid != this.props.grid){
				this.state.columns = this.setGrid(props);
			}
			if(props.mines != this.props.mines) {
				this.state.total_bombs = (props.mines != undefined) ? props.mines : 10;
			}
			if(props.cell_color != this.props.cell_color) {
				this.cell_bg_color = 'rgba(' + props.cell_color + ',1)';
			}
			this.resetGame();
			//this.gameInit();

			this.setState({...this.state});
		}
		if(props.to_reset != this.props.to_reset) this.resetGame();
		if(props.show_result != this.props.show_result) this.state.show_result = props.show_result;
	}

	nestedArray(row, col) {
		var outerArray = [];
		for(var i = 0; i < row; i++) {
			var innerArray = [];
			for(var j = 0; j < col; j++) {
				innerArray.push("");
			}
			outerArray.push(innerArray);
		}

		return outerArray;
	}

	populateNestedArray(nestedArray, val, count) {
		if(_size(this.state.bombs)>0) this.state.bombs = [];
		while(count) {
			let y = this.floorRand(this.state.columns);
			let x = this.floorRand(this.state.columns);
			if(!nestedArray[y][x]) {
				nestedArray[y][x] = val;
				this.state.bombs.push(y + "_" + x);
				count--;
			}
		}
		this.state.bombs.sort();

		return nestedArray;
	}

	floorRand(scale) {
		return Math.floor(Math.random() * scale);
	}

	valsAdjacentCounts(nestedArray,val) {
		for(var i = 0; i < nestedArray.length; i++) {
			for(var j = 0; j < nestedArray[0].length; j++) {
				if(nestedArray[i][j] === val) {
					nestedArray = this.addOneNestedArrAdjacents(nestedArray, i, j, val);
				}
			}
		}

		return nestedArray;
	}

	addOneNestedArrAdjacents(nestedArray, i, j, val) {
		let iList = [i-1, i, i+1];
		let jList = [j-1, j, j+1];

		for(var a of iList) {
			if(nestedArray[a]) {
				for(var b of jList) {
					if(nestedArray[a][b] !== undefined && nestedArray[a][b] !== val) {
						if(typeof nestedArray[a][b] !== "number") nestedArray[a][b] = 0;
						nestedArray[a][b]++;
					}
				}
			}
		}
		return nestedArray;
	}

	chargeAreas() {
		var area = [];
		for(var i=0; i<this.state.columns; i++) {
			for(var j=0;j<this.state.columns; j++) {
				if(this.state.map[i][j]=='' && !this.isCellArea(i+'_'+j)) {
					area.push(this.recursionArea(j,i));
				}
			}
		}
		this.setState({areas: area});
	}

	recursionArea(column,row, array = []) {
		let colList = [column - 1, column, column + 1];
		let rowList = [row - 1, row, row + 1];
		let is_size;

		for(let x of rowList) {
			for(let y of colList) {
				if(x > -1 && x < this.state.columns && y > -1 && y < this.state.columns) {
					const this_id = x+"_"+y;
					if(_size(array)!=0 && array !=undefined) {
						is_size = array.filter((obj) => { return obj == this_id })[0];
						is_size = (is_size!=undefined) ? true : false;
					} else {
						is_size = false;
					}
					if(this.state.map[x][y]==this.clear_char_id && !is_size) {
						array.push(this_id);
						array = this.recursionArea(y,x,array);
					} else if(this.state.map[x][y]!=this.bomb_char_id && !is_size) {
						array.push(this_id);
					}
				}
			}
		}
		return array;
	}

	isCellArea(id) {
		if(_size(this.state.areas)==0) return false;
		const is_area = this.state.areas.map((arr)=>{
			arr.filter((obj) => { return obj == id; });
		});
		return (is_area != undefined) ? true : false;
	}

	loadImages(bomb,flag) {
		if(bomb)this.loadBombImage(bomb);
		if(flag)this.loadFlagImage(flag);
	}

	loadBombImage(bomb) {
		this.bomb_image = new window.Image();
		this.bomb_image.crossOrigin = 'Anonymous';
		this.bomb_image.src = bomb;
		this.bomb_image.onload = () => {
			var img = this.bomb_image;
			this.state.bomb_image_obj = {
				fillPatternImage:img,
				image_w:img.width,
				image_h:img.height,
				size_piece_w:img.width / this.state.columns,
				size_piece_h:img.height / this.state.columns,
			}
			this.state.bomb_image = true;
			this.setState({...this.state});
		}
	}

	loadFlagImage(flag) {
		this.flag_image = new window.Image();
		this.flag_image.crossOrigin = 'Anonymous';
		this.flag_image.src = flag;
		this.flag_image.onload = () => {
			var img = this.flag_image;
			this.state.flag_image_obj = {
				fillPatternImage:img,
				image_w:img.width,
				image_h:img.height,
				size_piece_w:img.width / this.state.columns,
				size_piece_h:img.height / this.state.columns,
			}
			this.state.flag_image = true;
			this.setState({...this.state});
		}
	}

	clickCell(id, force_execution) {
		if(force_execution == undefined) force_execution = false;
		if(!this.isCellClicked(id) || force_execution) {
			if(force_execution) this.clickCellPlay();
			if(!this.isCellBombed(id)) {
				setTimeout(() => {
					if(this.props.onHitResult != undefined) this.props.onHitResult();
				},0);
			}
			this.state.clicks.push(id);
			this.state.clicks.sort();
		}
	}

	isCellClicked(id) {
		const is_clicked = this.state.clicks.filter((obj) => { return obj == id; })[0];
		return (is_clicked != undefined) ? true : false;
	}

	flagCell(id,force_flag=false) {
		if(this.state.ended || this.isCellClicked(id)) return false;

		if(this.isCellFlagged(id) && !force_flag) {
			this.unflagCellPlay();
			this.state.flags = _remove(this.state.flags, (n) => { return n != id; });
		} else if(_size(this.state.flags) < this.state.total_bombs) {
			this.flagCellPlay();
			this.state.flags.push(id);
			this.state.flags.sort();
			this.setState({ ...this.state });
			this.isSolved();
		}
		let left_flags = this.state.total_bombs - _size(this.state.flags);
		if(this.props.setNumFlags != undefined) this.props.setNumFlags(left_flags);
	}

	isCellFlagged(id) {
		const is_flagged = this.state.flags.filter((obj) => { return obj == id; })[0];
		return (is_flagged != undefined) ? true : false;
	}

	isCellBombed(id) {
		const is_bombed = this.state.bombs.filter((obj) => { return obj == id; })[0];
		return (is_bombed != undefined) ? true : false;
	}

	failGame(killing_bomb) {
		this.setState({ ended:true, exploded_bomb:killing_bomb});
		this.clickAndExplodeBombPlay();
		const stage = this.refs['stage'];
		if(this.props.onSolve != undefined) this.props.onSolve(false, {img:stage.toDataURL(),error_type:'fail'});
	}

	isSolved() {
		var is_solved = true;
		// GAME VALIDATION
		this.flagged_bombs = [];
		this.state.bombs.map((bomb, b) => {
			if(this.isCellFlagged(bomb)) {
				this.flagged_bombs.push(bomb);
			}
		});
		let total = Math.pow(this.state.columns,2);
		if(_size(this.state.clicks)!=(total-this.state.total_bombs) || _size(this.flagged_bombs) != _size(this.state.bombs)) {
			is_solved = false;
		} else {
			this.flagCellPlay();
		}

		this.setState({ ended:is_solved, solved:is_solved });

		if(is_solved){
			this.flagCellAndSuccessPlay();
			const stage = this.refs['stage'];
			//if(this.props.onHitResult != undefined) this.props.onHitResult();
			if(this.props.onSolve != undefined) this.props.onSolve(is_solved, { img:stage.toDataURL() });
		}
	}

	onFlagCell(e) {
		e.evt.preventDefault();

		let is_click_right = e.evt.type == 'contextmenu' ? true : false;

		//if(this.state.flagger && e.evt.type == 'contextmenu') return true;

		const target = e.target.attrs;

		this.flagCell(target.id,false);

		this.flag_event = true;
	}

	onClickCell(e) {
		/*if(this.state.flagger) {
			this.onFlagCell(e);
		}*/
		
		this.flag_event = e.evt.button == 2 ? true : false;

		const target = e.target.attrs;
		if(this.state.ended) return false;

		if(!this.flag_event && !this.isCellFlagged(target.id) && !this.isCellClicked(target.id)) {

			this.clickCell(target.id, true);

			if(!this.state.ended) {
				if(this.state.map[target.pos_y][target.pos_x] === this.clear_char_id) {
					this.prepareZone(target.pos_y, target.pos_x);
				} else if(this.state.map[target.pos_y][target.pos_x] === this.bomb_char_id) {
					this.failGame(target.id);
				}
			}

			this.setState({...this.state});
			let total = Math.pow(this.state.columns,2);
			if(_size(this.state.clicks)==(total-this.state.total_bombs) && (this.state.map[target.pos_y][target.pos_x] != this.bomb_char_id)) {
				this.forceFinishGame();
			}
		} else {
			this.flag_event = false;
		}
	}

	forceFinishGame() {
		this.setState({flags:this.state.bombs});
		this.isSolved();
	}

	prepareZone(row, col) {
		var j = [];
		for(var i=0;i<_size(this.state.areas);i++) {
			for(var e=0;e<_size(this.state.areas[i]);e++) {
				if(this.state.areas[i][e]==row+'_'+col){
					j.push(i);
				}
			}
		}
		if(_size(j)!=0) {
			for(i=0;i<_size(j);i++) {
				for(var e=0;e<_size(this.state.areas[j[i]]);e++) {
					if(!this.isCellFlagged(this.state.areas[j[i]][e])){
						this.clickCell(this.state.areas[j[i]][e]);
					}
				}

			}
		}
	}

	gameInit(from_resize) {
		if(from_resize == undefined) from_resize = false;

		if(this.props.adaptToContainer != undefined) this.props.adaptToContainer((size) => {
			this.size = size;

			if(!from_resize) {
				var nestedArray = this.populateNestedArray(this.nestedArray(this.state.columns, this.state.columns), this.bomb_char_id, this.state.total_bombs);
				this.state.map = this.valsAdjacentCounts(nestedArray, this.bomb_char_id);
				this.chargeAreas(nestedArray);
			}

			//this.setState({ ...this.state });
			this.state.full_loaded = true;
			this.setState({...this.state});
		});
		if(this.props.setNumFlags != undefined) this.props.setNumFlags(this.state.total_bombs);
	}

	resetGame() {
		this.state.bombs = [];
		this.state.clicks = [];
		this.state.flags = [];
		this.state.full_loaded = false;
		this.state.map = [];
		this.state.solved = false;
		this.state.ended = false;
		this.state.show_result = false;
		this.state.exploded_bomb = '';
		this.setState({...this.state});
		this.gameInit();
	}

	handleButtonPress(e) {
		if(this.device == 'mobile') {
			this.buttonPressTimer = setTimeout(() => {
				this.createZonePress(e);
				this.onFlagCell(e);
			}, 600);
		}
	}

	handleButtonRelease() {
		clearTimeout(this.buttonPressTimer);
		this.setState({zone_press:false});
	}

	createZonePress(e) {
		const target = e.target.attrs;
		if(!this.state.ended && !this.state.show_result) {
			const id = target.pos_y + '_' + target.pos_x;
			let make_click = true;
			this.state.clicks.map((item) => {
				if(item == id) make_click = false;
			});

			if(make_click) {
				const movement_left = Math.floor(this.longitude_zone / 2);
				const size_portion = this.size / this.state.columns;

				let zone_press = {};
				var min_x = target.pos_x - movement_left;
				var min_y = target.pos_y - movement_left;

				zone_press.position = 'absolute';
				//zone_press.backgroundColor = 'yellow';
				zone_press.left = size_portion * min_x;
				zone_press.top = size_portion * min_y;
				zone_press.width = size_portion * this.longitude_zone;
				zone_press.height = size_portion * this.longitude_zone;

				this.setState({zone_press:zone_press});
			}
		}
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const size_portion = this.size / this.state.columns;
		const theme = (this.props.theme != undefined) ? this.props.theme : 'light';

		const bomb_image = (this.state.bomb_image) ? this.state.bomb_image_obj : false;
		const slide_size_bomb = (bomb_image) ? this.size / this.state.columns / (Math.max(bomb_image.image_w, bomb_image.image_h)) : false;

		const flag_image = (this.state.flag_image) ? this.state.flag_image_obj : false;
		const slide_size_flag = (flag_image) ? this.size / this.state.columns / (Math.max(flag_image.image_w, flag_image.image_h)) : false;

		var count_cell = 0;
		var tapper_count_cell = 0;
		var zone_press_counter = 0;

		const show_result = this.state.show_result;
		const zone_press = this.state.zone_press;

		const display_legend = true;
		const has_layer_opened = (this.state.display_controls !== false || this.state.display_instructions !== false) ? true : false;

		return (
			<aside class="game_container is_minesweeper">
				<div class={'canvas_content is_' + theme}>
					<img src={window.cdn_url + 'img/blank_1x1.png'} class="img_pusher" alt="" />

					{(has_layer_opened) && (
						<div class={'game_blocker is_fullscreen relative_to_container ' + ((theme == 'light') ? 'white' : 'black') + 'Bg'} onClick={() => this.closeAllLayer()} />
					)}

					{(this.state.full_loaded) ? (
						<Stage className={'canvas_cont' + ((this.device != 'desktop') ? ' gui_hidden_overflowed' : '')} width={this.size} height={this.size} ref="stage">
							<Layer ref="layer">
								<Rect
									x={0}
									y={0}
									fill={(theme == 'light') ? 'white' : 'black'}
									width={this.size}
									height={this.size}
								/>

								<Group>
									{this.state.map.map((row, y) => {
										return (
											row.map((letter, x) => {
												letter = (letter != '') ? letter : this.clear_char_id;
												const init_x = size_portion * Math.floor((count_cell) % this.state.columns);
												const init_y = size_portion * Math.floor((count_cell) / this.state.columns);
												count_cell += 1;

												const id = y + '_' + x;

												if(this.isCellFlagged(id) || this.isCellBombed(id)) {
													var cell_id;
													var cell_image;
													var cell_image_scale;
													var cell_color;
													var SVGIcon;

													const hasFlagAndNotBomb = this.isCellFlagged(id) && !this.isCellBombed(id) && (this.state.ended || show_result) ? true : false;

													if(this.isCellFlagged(id) && !hasFlagAndNotBomb) {
														cell_id = id + '_flag';
														cell_image = (this.props.flag_img) ? flag_image : false;
														cell_image_scale = slide_size_flag;
														cell_color = this.flag_bg_color;
														SVGIcon = DefaultFlagIcon;
													} else if(this.isCellBombed(id) || hasFlagAndNotBomb) {
														cell_id = id + '_bomb';
														cell_image = (this.props.mine_img) ? bomb_image : false;
														cell_image_scale = slide_size_bomb;
														cell_color = (id == this.state.exploded_bomb) ? this.exploded_bomb_bg_color : 'transparent';
														SVGIcon = DefaultMineIcon;
													}

													return (
														<Group
															key={cell_id}
															x={init_x}
															y={init_y}
															width={size_portion}
															height={size_portion}
															>
															<Rect
																width={size_portion}
																height={size_portion}
																fill={cell_color}
															/>

															{(!cell_image) ? (
																<SVGIcon
																	theme={theme}
																	size_portion={size_portion}
																	path_scale={size_portion * 0.85 * 0.04}
																/>
															) : (
																<Rect
																	width={cell_image.image_w * cell_image_scale}
																	height={cell_image.image_h * cell_image_scale}
																	offsetX={-(size_portion - cell_image.image_w * cell_image_scale) / 2}
																	offsetY={-(size_portion - cell_image.image_h * cell_image_scale) / 2}
																	fillPatternImage={cell_image.fillPatternImage}
																	fillPatternRepeat='no-repeat'
																	fillPatternScaleX={cell_image_scale}
																	fillPatternScaleY={cell_image_scale}
																/>
															)}

															{(hasFlagAndNotBomb) && (
																<CrossSVG
																	size_portion={size_portion}
																	path_scale={size_portion * 0.85 * 0.03}
																/>
															)}
														</Group>
													)
												}

												return (
													<Text
														key={id + '_number'}
														x={init_x}
														y={init_y + size_portion * 0.05}
														width={size_portion}
														height={size_portion}
														fontSize={size_portion * 0.6}
														fontFamily='Helvetica'
														fill={(theme == 'light') ? 'black' : 'white'}
														wrap='char'
														align='center'
														verticalAlign='middle'
														text={letter}
													/>
												)
											})
										)
									})}
								</Group>

								{this.state.map.map((row, y) => {
									if(show_result)return null;

									return (
										row.map((letter, x) => {
											const init_x = size_portion * Math.floor((tapper_count_cell) % this.state.columns);
											const init_y = size_portion * Math.floor((tapper_count_cell) / this.state.columns);
											tapper_count_cell += 1;

											const id = y + '_' + x;

											var fill = this.cell_bg_color;
											//fill = 'transparent';

											if(!this.state.ended) {
												this.state.clicks.map((item) => {
													if(item == id) fill = 'transparent';
												});

												this.state.flags.map((item) => {
													if(item == id) fill = 'transparent';
												});
											} else {
												fill = 'transparent';
											}

											return (
												<Rect
													ref={'bg_' + id}
													key={id + '_bg'}
													id={id}
													strokeWidth={1}
													stroke={(theme == 'light') ? 'white' : 'black'}
													x={init_x}
													y={init_y}
													width={size_portion}
													height={size_portion}
													pos_x={x}
													pos_y={y}
													fill={fill}
													shadowBlur={0}
													onTap={this.onClickCell.bind(this)}
													onClick={this.onClickCell.bind(this)}
													onTouchStart={this.handleButtonPress.bind(this)}
													onTouchEnd={this.handleButtonRelease.bind(this)}
													//onMouseDown={this.handleButtonPress.bind(this)}
													//onMouseUp={this.handleButtonRelease.bind(this)}
													//onMouseLeave={this.handleButtonRelease.bind(this)}
													onContextMenu={this.onFlagCell.bind(this)}
												/>
											)
										})
									)
								})}
							</Layer>
						</Stage>
					) : (
						<div class="gui_not_in_top gui_flex_center">
							<Spinner>Loading game</Spinner>
						</div>
					)}

					{(zone_press !== false) && (
						<div style={zone_press}>
							{/*<div style={zone_press} onTouchEnd={() => this.handleButtonRelease()}>*/}
							<FlaggingMobileFX
								color={this.flag_bg_color}
								size_portion={size_portion}
								path_scale={size_portion * 0.85 * 0.04}
								longitude_zone={5}
							/>
						</div>
					)}
				</div>

				{(display_legend) && (
					<div class="game_legend gui_main_text_color_on_bg">
						{/*items.map((item, i) => {
							const item_found = (item.found != undefined && item.found) ? item.found : false;

							return (
								<span key={i} class={'cutTextOnOverflow' + ((item_found) ? ' selected' : '')}><span class="original_color_item">{item.word}</span></span>
							)
						})*/}
						<div class="game_controls_link in_top">
							<ActionLink _class={{other:'gui_main_text_color_on_bg gui_underlined_text'}} onClick={() => this.displayControls()}>Controls</ActionLink>

							{(this.state.display_controls !== false) && (
								<div class="controls_layer">
									<div class="contextual_menu original_color_item">
										<div>
											<p><strong>{i18n((this.device == 'desktop') ? "Click" : "Tap")}</strong></p>

											<MineSweeperControls
												device={this.device}
												action='opening'
												theme={theme}
												cell_color={`rgba(${this.props?.cell_color ?? ((theme == 'light') ? '255, 255, 255' : '0, 0, 0')}, 1)`}
											/>
										</div>

										<div>
											<p><strong>{i18n((this.device == 'desktop') ? "Right-click" : "Long-tap")}</strong></p>

											<MineSweeperControls
												device={this.device}
												action='flagging'
												theme={theme}
												cell_color={`rgba(${this.props?.cell_color ?? ((theme == 'light') ? '255, 255, 255' : '0, 0, 0')}, 1)`}
											/>
										</div>
									</div>
								</div>
							)}
						</div>

						<div class="game_instructions_link in_top">
							<ActionLink _class={{other:'gui_main_text_color_on_bg gui_underlined_text'}} onClick={() => this.displayInstructions()}>How to play?</ActionLink>

							{(this.state.display_instructions !== false) && (
								<div class="instructions_layer">
									<div class="contextual_menu">
										<p><strong class="original_color_item blackColor">{i18n("How to play?")}</strong></p>
										<ol class="list">
											<li class="original_color_item blackColor">{i18n("The goal of the game is to open all squares that don't contain a mine. Click on a square to open it.")}</li>
											<li class="original_color_item blackColor">{i18n("If you open a square with a mine, you lose the game.")}</li>
											<li class="original_color_item blackColor">{i18n("The number on a square refers to how many mines are hidden in the surrounding squares.")}</li>
											<li class="original_color_item blackColor">{i18n("By clicking on a square without a number you automatically open all surrounding squares that don't contain mines.")}</li>
											<li class="original_color_item blackColor">{i18n("Each time you open a square without a mine, you obtain 10 points.")}</li>
											<li class="original_color_item blackColor">{i18n("Flag the squares which you think contain mines to solve the game easier.") + " " + i18n((this.device == 'desktop') ? "Right-click on the square to flag it." : "Long tap the square to flag it.")}</li>
										</ol>
									</div>
								</div>
							)}
						</div>
					</div>
				)}
			</aside>
		)
	}
}

export default injectIntl(MineSweeperCanvas);